import adminApi from '@/lib/adminApi';

export const resolveAdminCityLocation = async (city, country = 'India') => {
  const cleanCity = String(city || '').trim();
  if (cleanCity.length < 2) return null;
  const response = await adminApi.get('/admin/location/resolve', {
    params: {
      city: cleanCity,
      country: String(country || 'India').trim() || 'India',
    },
  });
  return response.data?.resolved ? response.data : null;
};
